import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalContentComponent } from '../../../component/modal-content/modal-content.component';

@Component({
  selector: 'app-condition-query-lookup-type',
  templateUrl: './condition-query-lookup-type.component.html',
  styleUrl: './condition-query-lookup-type.component.scss'
})
export class ConditionQueryLookupTypeComponent extends FieldType {

  isModalOpen: boolean = false;
  modalRef!: BsModalRef;
  text: string = "";
  @ViewChild('value') lookupCodeBox!: ElementRef;
  isChecked: boolean = false;

  onCheckboxChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.isChecked = input.checked;
    this.lookupCodeBox.nativeElement.value=null
    this.text = '';
  }

  constructor(private modalService: BsModalService,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
      if (this.formControl.value) {
        this.isChecked = true;
        this.text = this.props["defaultValue"]!;
      } else {
        this.isChecked = false;
      }
  }

  manageCheck() {
    if (this.isChecked) {
      this.isChecked = !this.isChecked;
      if (!this.isChecked) {
        this.text = "";
        this.lookupCodeBox.nativeElement.value=null;
        this.formControl.setValue(null);
      }
    }
  }


  openModal() {
  
    let value = this.formControl.getRawValue();

    if (this.isModalOpen) return;
    this.isModalOpen = true; // Set flag to true

    //Retrieve the lookup metadata object
    const lookup: any = this.field.props!['lookup'];

    //Show modal dialog
    this.modalRef = this.modalService.show(ModalContentComponent,
      {
        initialState: {
          message: { lookup: lookup, selectedValue: value }
        }
      }
    );

    //Close modal suscription 
    this.modalRef.onHidden!.subscribe(() => {
      this.isModalOpen = false;
      if (this.modalRef.content.selectedName) {
        if (this.modalRef.content.selectedName === "blank") {
          this.text = "";
          this.formControl.setValue(null);
          this.isChecked=false;
        } else {
          this.text = this.modalRef.content.selectedName;
          this.isChecked=true;
          this.formControl.setValue(this.modalRef.content.selectedCode);
          this.props["defaultValue"]=this.text;
        }
      }
      this.cdRef.detectChanges();
    });
  }

  onInputChange() {
    if (this.formControl.value) {
      this.isChecked = true;
      this.props['isModified'] = true;
       this.props['defaultValue'] = this.formControl.value;
   } else {
      this.isChecked = false;
      this.text="";
      this.props['isModified'] = false;
      this.props['defaultValue'] = null;
    }
  }

}
